import { makeStyles, Theme, useTheme } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import { VseDisclaimer } from 'vse-material-ui';

const useStyles = makeStyles((theme: Theme) => ({
  main: {
    flex: 1,
    padding: theme.spacing(1, 1),
  },
  paper: {
    margin: 'auto',
    padding: theme.spacing(2),
    overflow: 'hidden',
    '& p': {
      marginBottom: theme.spacing(2),
    },
    '& p + h6': {
      marginTop: theme.spacing(1),
    },
  },
}));

export function Disclaimer() {
  const theme = useTheme();
  const classes = useStyles(theme);

  return (
    <main className={classes.main}>
      <Paper className={classes.paper}>
        <VseDisclaimer />
      </Paper>
    </main>
  );
}
